import { Pipe, PipeTransform } from '@angular/core';

import { Duration } from '@fcom/dapi';

/**
 * @deprecated
 *
 * Should be removed after translations are updated to with named parameters for bookingSearch.duration
 */
@Pipe({
  name: 'finTemporaryDurationPipe',
  standalone: false,
})
export class TemporaryDurationPipe implements PipeTransform {
  transform(duration: Duration): Record<string, string | number> {
    return Object.assign({ 0: duration.hours, 1: duration.minutes }, duration) as unknown as Record<
      string,
      string | number
    >;
  }
}
